import React from 'react';
import { Provider } from 'react-redux';
import ReduxToastr from 'react-redux-toastr';
import { applyMiddleware, createStore } from 'redux';
import { composeWithDevTools } from 'redux-devtools-extension';
import multi from 'redux-multi';
import promise from 'redux-promise';
import thunkMiddleware from 'redux-thunk';

import reducers from '../../reducers';
import Page from './page';

const middleware = composeWithDevTools(applyMiddleware(promise, multi, thunkMiddleware))

const store = createStore(reducers, middleware);

const EditarUsr = (props) => (
    <Provider store={store}>
        <Page options={props} auth={props.auth} />
        <ReduxToastr/>
    </Provider>
);

export default EditarUsr;
